// extracted by mini-css-extract-plugin
export default {"component":"DeleteCategoryButton_component__eB8qt"};